import * as _ from "lodash";

import { STATES_BY_ABBREVIATION } from "@stw/states";

export const STATE_MENU_OPTIONS: {
  label: string;
  value: string;
}[] = _.sortBy(
  Object.entries(STATES_BY_ABBREVIATION).map(([abbreviation, state]) => {
    return {
      label: state.name,
      value: abbreviation,
    };
  }),
  "label"
);
